var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"productList"}},[_c('ProductRecommList'),_c('ProductList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }